import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Col, Drawer, Row, Space, Table, Tag, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  USER_BANK_LIST,
} from "../../../../lib/config";
import { GetDataListById } from "../../../../lib/api";
import UserBankForm from "./form";
import toast from "react-hot-toast";

const { Text } = Typography;
export default function UserBank({ detail }) {
  const { access_token, permissions, csrf_token } = useSelector(
    (state) => state.user
  );

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getDataList() {
    setLoading(true);
    await GetDataListById(USER_BANK_LIST, detail.id, access_token, csrf_token)
      .then(({ data: { data: res } }) => {
        setLoading(false);

        setList(res);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList();
  }, []);

  const columns = [
    {
      title: "Bank Type",
      dataIndex: "bank_type",
      render : (record) => {
        return renderBankOption(record)
      }
    },
    {
      title: "Name",
      dataIndex: "acc_name",
    },

    {
      title: "Account No.",
      dataIndex: "acc_number",
    },
  ];
  const openDrawer = () => setShowForm(true);

  function closeDrawer(key) {
    setShowForm(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }


  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 30, height: 30, borderRadius:"5px" }}
        />
      </div>
    );
  }


  return (
    <>
      <Row gutter={[0, 16]} justify={"end"}>
        <Col>
          {permissions.includes("AGENT_CREATE_USER_BANK_ACCOUNT") && (
            <Button type="primary" onClick={openDrawer} icon={<PlusOutlined />}>
              New Bank Account
            </Button>
          )}
        </Col>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={list}
            rowKey={(e) => e.id}
            loading={loading}
            pagination={false}
          />
        </Col>
      </Row>
      <Drawer
        open={showForm}
        title="Create Bank Account"
        onClose={() => setShowForm(false)}
        destroyOnClose
        placement="right"
        width={"500px"}
      >
        <UserBankForm closeDrawer={closeDrawer} detail={detail} />
      </Drawer>
    </>
  );
}
